/**
 * Run-time routes for tour steps that live on a per-record screen: the
 * user's latest report, or their first mentee's workspace. `null` means the
 * user has none yet, so the step shows as a centered "where to find it" card.
 */
import { chatAPI } from '../services/api';
import { MentorEngagementsAPI } from '../services/api/mentorEngagementsAPI';
import type { TourStepDef } from './tourModel';

type DynamicRoute = NonNullable<TourStepDef['dynamicRoute']>;

async function latestReportRoute(): Promise<string | null> {
  const sessions = await chatAPI.getSessions();
  const analysed = (sessions || [])
    .filter((session) => session.session_type === 'analysis')
    .sort((a, b) => String(b.created_at).localeCompare(String(a.created_at)));
  return analysed[0] ? `/report/${analysed[0].id}` : null;
}

async function firstEngagementRoute(): Promise<string | null> {
  const engagements = await MentorEngagementsAPI.list();
  const open = (engagements || []).find(
    (engagement) => engagement.status !== 'archived' && engagement.mentee_name !== null,
  );
  return open ? `/mentor/engagements/${open.id}` : null;
}

export async function resolveTourRoute(kind: DynamicRoute): Promise<string | null> {
  try {
    return kind === 'latest_report' ? await latestReportRoute() : await firstEngagementRoute();
  } catch {
    // No route is a safe answer: the step falls back to the centered card.
    return null;
  }
}
